export default __webpack_public_path__ + "static/media/project-on-hold-status.68f2b38c.svg";